import VueRouter from 'vue-router';
// Pages
import ITStartup from './components/landing-pages/ITStartup';
import WebDevelopment from './components/landing-pages/it-startup/services/WebDevelopment';
import SoftwerDevelopment from './components/landing-pages/it-startup/services/SoftwerDevelopment';
import SearchEngineOptimisation from './components/landing-pages/it-startup/services/SearchEngineOptimisation';
import MobileAppDevelopment from './components/landing-pages/it-startup/services/MobileAppDevelopment';
import ITConsultancy from './components/landing-pages/it-startup/services/ITConsultancy';
import DigitalMarketing from './components/landing-pages/it-startup/services/DigitalMarketing';
import ECommerce from './components/landing-pages/it-startup/services/ECommerceDevelopment';
import UiUxDesign from './components/landing-pages/it-startup/services/UiUxDesign';
import DomainHosting from './components/landing-pages/it-startup/services/DomainHosting';
import AboutStyleOne from './components/other-pages/about/AboutStyleOne';
import Privacy from './components/other-pages/privacy/Privacy';
import ServiceGlance from './components/other-pages/service-glance/ServiceGlance';
import Features from './components/other-pages/features/Features';
import FeatureDetails from './components/other-pages/features/FeatureDetails';
import ServicesTwo from './components/other-pages/services/ServicesOne';
import ServiceDetails from './components/other-pages/services/ServiceDetails';
import ProjectDetails from './components/other-pages/projects/ProjectDetails';
import Team from './components/other-pages/team/Team';
import Pricing from './components/other-pages/pricing/Pricing';
import Faq from './components/other-pages/faq/Faq';
import NotFound from './components/other-pages/not-found/NotFound';
import ComingSoon from './components/other-pages/coming-soon/ComingSoon';
import BlogRightSidebarTwo from './components/other-pages/blog/BlogRightSidebarTwo';
import WhyECommerce from './components/landing-pages/it-startup/blogs/WhyECommerce';
import NeedDigitalMarketing from './components/landing-pages/it-startup/blogs/NeedDigitalMarketing';
import AppVsWeb from './components/landing-pages/it-startup/blogs/AppsVsWeb';
import NeedApps from './components/landing-pages/it-startup/blogs/NeedApps';
import NeedWebSide from './components/landing-pages/it-startup/blogs/NeedWebSide';
import WhyRestudent from './components/landing-pages/it-startup/blogs/WhyRestudent';
import Contact from './components/other-pages/contact/Contact';

export const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
    routes: [
      { path: '/', component: ITStartup },
      { path: '/about', component: AboutStyleOne },
      { path: '/features', component: Features },
      { path: '/feature-details', component: FeatureDetails },
      { path: '/service', component: ServicesTwo },
      { path: '/service-glance', component: ServiceGlance },
      { path: '/privacy', component: Privacy },
      { path: '/service-details/Web-Development', component: WebDevelopment },
      { path: '/service-details/Softwer-Development', component: SoftwerDevelopment },
      { path: '/service-details/Search-Engine-Optimisation', component: SearchEngineOptimisation },
      { path: '/service-details/Mobile-App-Development', component: MobileAppDevelopment },
      { path: '/service-details/IT-Consultancy', component: ITConsultancy },
      { path: '/service-details/Digital-Marketing', component: DigitalMarketing },
      { path: '/service-details/E-Commerce', component: ECommerce },
      { path: '/service-details/UiUxDesign', component: UiUxDesign },
      { path: '/service-details/DomainHosting', component: DomainHosting },
      { path: '/service-details/', component: ServiceDetails },
      { path: '/project-details', component: ProjectDetails },
      { path: '/team', component: Team },
      { path: '/pricing', component: Pricing },
      { path: '/faq', component: Faq },
      { path: '/coming-soon', component: ComingSoon },
      { path: '/not-found', component: NotFound },
      { path: '/blogs', component: BlogRightSidebarTwo },
      { path: '/blog-details/WhyECommerce', component: WhyECommerce },
      { path: '/blog-details/NeedDigitalMarketing', component: NeedDigitalMarketing },
      { path: '/blog-details/AppVsWeb', component: AppVsWeb },
      { path: '/blog-details/NeedApps', component: NeedApps },
      { path: '/blog-details/NeedWebSide', component: NeedWebSide },
      { path: '/blog-details/WhyRestudent', component: WhyRestudent },
      { path: '/contact', component: Contact },
      
    ]
});